import { genericPage, getMappingProgramaSlug, getServerSidePropsHelper } from 'components/3cat/Page';
import { useRouter } from 'next/router';
// /nom-coleccio/coleccio/id/
const path = ['web', process.env.FOLDER_LAYOUTS, 'coleccio', 'id'];

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, path);
};

export async function getServerSideProps(context) {
    const { slug, id } = context.query;
    const mapping = await getMappingProgramaSlug(slug);

    if (!Number.isInteger(parseInt(id))) {
        return {
            notFound: true
        };
    }

    const options = {
        slugs: path,
        id: mapping.id
    };

    return getServerSidePropsHelper(context, options);
}

export default Pagina;
